import { Link } from "react-router-dom";

export default function HeroPromo() {
  return (
    <section aria-label="Dinámica ALÉA">
      <img src="/images/promotions/dinamica-banner-v1.jpg" alt="Participa en la dinámica ALÉA"
        width={1374} height={1145} className="block h-auto w-full" fetchPriority="high" decoding="async" />
      <div className="flex justify-center px-5 pb-1 pt-5">
        <Link to="/alea-90"
          className="inline-flex min-h-14 w-full max-w-[260px] cursor-pointer items-center justify-center rounded-full border border-[#a67b2e] px-8 py-3 font-heading text-lg font-extrabold tracking-wide text-[#34240e] transition-transform hover:-translate-y-0.5 active:translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#a67b2e]"
          style={{background:"linear-gradient(165deg, #fff0bd 0%, #efd495 20%, #c79945 48%, #f3dca0 52%, #d1a455 78%, #b18435 100%)",
            boxShadow:"inset 0 2px 2px #fff5d4, inset 0 -3px 3px #80591d80, 0 4px 0 #8b652a, 0 8px 13px #5c401b30",
            textShadow:"0 1px 0 #fff1c799"}}>
          Regístrate
        </Link>
      </div>
    </section>
  );
}
